(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 8581:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(5635);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(7379);
// EXTERNAL MODULE: ./src/components/molecules/common/HorizontalSlider.js
var HorizontalSlider = __webpack_require__(8000);
// EXTERNAL MODULE: ./src/cds/buttons/Outline.tsx
var Outline = __webpack_require__(5472);
// EXTERNAL MODULE: ./src/slices/search.thunk.js + 1 modules
var search_thunk = __webpack_require__(7687);
// EXTERNAL MODULE: ./src/hooks/common/useStore.ts
var useStore = __webpack_require__(8004);
// EXTERNAL MODULE: ./src/lib/utils/deviceChecker.js
var deviceChecker = __webpack_require__(7496);
// EXTERNAL MODULE: ./src/lib/utils/array.js
var array = __webpack_require__(8224);
// EXTERNAL MODULE: ./src/cds/styles.ts
var styles = __webpack_require__(3887);
// EXTERNAL MODULE: ./src/slices/dataMining.ts
var dataMining = __webpack_require__(7990);
;// CONCATENATED MODULE: ./src/components/organisms/main/PopularityTagList.js





// components


// slices

// hooks

// utils


// styles


function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 1800px;\n  max-width: 100%;\n  padding: 20px 32px;\n  margin: 0 auto;\n\n  & ul {\n    padding: 0;\n  }\n\n  & li {\n    & ~ * {\n      margin-left: 8px;\n    }\n  }\n\n  ",
        " {\n    padding: 20px 72px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  flex-grow: 0;\n  height: 32px;\n  padding: 0 12px;\n  white-space: nowrap;\n  border: 1px solid ",
        ";\n  border-radius: 32px;\n  color: ",
        ";\n  font-size: 14px;\n  background-color: transparent;\n  &:hover {\n    background-color: transparent;\n    opacity: 1;\n    color: ",
        ";\n  }\n  &::before {\n    z-index: 0;\n    border-radius: 32px;\n  }\n\n  & > div {\n    padding-right: 8px;\n    margin-left: 4px;\n    z-index: 1;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
/**
 * 인기 태그 리스트
 */ var PopularityTagList = function() {
    var router = (0,next_router.useRouter)();
    var dispatch = (0,useStore/* useDispatch */.I)();
    var tagList = (0,useStore/* useSelector */.v)(function(state) {
        return state.search.keywordRankList;
    });
    var ref = (0,react.useState)(null), TagList = ref[0], setTagList = ref[1];
    var ref1 = (0,react.useState)(false), isIpadApp = ref1[0], setIsIpadApp = ref1[1];
    // ipadApp check
    (0,react.useEffect)(function() {
        var device = (0,deviceChecker/* default */.Z)();
        setIsIpadApp(device.iPadApp());
    }, []);
    /** 인기 태그 리스트 호출 */ (0,react.useEffect)(function() {
        if (!router.isReady) {
            return;
        }
        if (isIpadApp) {
            return;
        }
        if (tagList.length > 0) {
            return;
        }
        dispatch((0,search_thunk/* getSearchRanking */.Uo)());
    }, [
        dispatch,
        isIpadApp,
        router.isReady,
        tagList
    ]);
    var onClickItem = (0,react.useCallback)(function(e) {
        dispatch((0,dataMining/* setClickedItems */.KB)({
            innerText: e.target.textContent,
            elementType: 'tag'
        }));
    }, [
        dispatch
    ]);
    (0,react.useEffect)(function() {
        if (!tagList.length) {
            return;
        }
        /**
     * 커스텀 태크 리스트
     * - `암호화폐`, `세력` : 2021.10.27 Goni 요청건.
     */ var customTagList = [
            '놀면서 돈벌기'
        ];
        var updateTagList = tagList.concat(customTagList);
        var uniqueTagList = _toConsumableArray(new Set(updateTagList));
        var output = (0,array/* getShuffledArray */.y)(uniqueTagList).map(function(tag, idx) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                onClick: onClickItem,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                    href: "/search?keyword=".concat(tag),
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagButton, {
                        as: "a",
                        children: tag
                    })
                })
            }, idx);
        });
        setTagList(output);
    }, [
        tagList,
        onClickItem
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(TagLayout, {
        className: "noselect",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HorizontalSlider/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    onClick: onClickItem,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                        href: "/search?keyword=",
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagButton, {
                            as: "a",
                            children: "전체"
                        })
                    })
                }),
                TagList
            ]
        })
    }));
};
var TagLayout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c5479645-0"
})(_templateObject(), styles/* mediaQuery.xlarge */.cy.xlarge);
var TagButton = (0,styled_components_browser_esm/* default */.ZP)(Outline/* default */.Z).withConfig({
    componentId: "sc-c5479645-1"
})(_templateObject1(), styles/* palette.system.grey */.DG.system.grey, styles/* palette.grey50 */.DG.grey50, styles/* palette.grey50 */.DG.grey50);
/* harmony default export */ var main_PopularityTagList = (PopularityTagList);

// EXTERNAL MODULE: ./src/cds/typography.ts
var typography = __webpack_require__(506);
// EXTERNAL MODULE: ./src/slices/user.thunk.js + 1 modules
var user_thunk = __webpack_require__(9001);
// EXTERNAL MODULE: ./src/lib/utils/companyConvert.js
var companyConvert = __webpack_require__(5836);
;// CONCATENATED MODULE: ./src/components/organisms/main/Exhibition.js





// utils

// styles





function Exhibition_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Exhibition_templateObject() {
    var data = Exhibition_taggedTemplateLiteral([
        "\n  overflow-x: auto;\n  overflow-y: hidden;\n  min-height: 54px;\n  padding: 0 16px 0;\n  white-space: nowrap;\n  scroll-behavior: smooth;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n    width: 0;\n    background-color: transparent;\n  }\n"
    ]);
    Exhibition_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Exhibition_templateObject1() {
    var data = Exhibition_taggedTemplateLiteral([
        "\n  display: inline-block;\n  min-width: 60px;\n  font-size: 0;\n  vertical-align: top;\n\n  & ~ & {\n    margin-left: 24px;\n  }\n\n  p {\n    color: ",
        ";\n  }\n"
    ]);
    Exhibition_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = Exhibition_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  margin: auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = Exhibition_taggedTemplateLiteral([
        "\n  overflow: hidden;\n  flex: 0 auto;\n  width: 44px;\n  height: 44px;\n  margin: 0 auto 4px;\n  background-image: ",
        ";\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = Exhibition_taggedTemplateLiteral([
        "\n  ",
        "\n  color: ",
        ";\n  white-space: initial;\n  word-break: keep-all;\n  text-align: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
/**
 * 메인 기획전 리스트
 * @param {object} props
 * @param {object[]} props.list
 */ var Exhibition = function(param) {
    var list = param.list;
    var ref;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)(false), isIpadApp = ref1[0], setIsIpadApp = ref1[1];
    var onMoveCommunity = function() {
        router.push('/community');
    };
    // ipadApp check
    (0,react.useEffect)(function() {
        var device = (0,deviceChecker/* default */.Z)();
        setIsIpadApp(device.iPadApp());
    }, []);
    var dispatch = (0,useStore/* useDispatch */.I)();
    var userInfo = (0,useStore/* useSelector */.v)(function(state) {
        return state.user.info;
    });
    var compulsory = (0,useStore/* useSelector */.v)(function(state) {
        return state.user.compulsory.enrolled;
    });
    var userCompany = (ref = (0,useStore/* useSelector */.v)(function(state) {
        return state.user.company;
    })) === null || ref === void 0 ? void 0 : ref.toLowerCase();
    (0,react.useEffect)(function() {
        if (router.pathname.split('/').includes('signin')) {
            return;
        }
        if (userInfo && userInfo.id) {
            dispatch((0,user_thunk/* getCompulsory */.Cj)({
                userId: userInfo.id
            }, {
                dispatch: dispatch
            }));
            dispatch((0,user_thunk/* getUserCompany */.pk)({
                userId: userInfo.id
            }, {
                dispatch: dispatch
            }));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        router.pathname,
        userInfo,
        userInfo.id
    ]);
    var Items = list.map(function(v) {
        if (!isIpadApp) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                    href: v.address,
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Thumb, {
                                url: v.icon2
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                children: v.title
                            })
                        ]
                    })
                })
            }, v.title));
        }
        var ignore = v.address.indexOf('/event') > -1 || v.address.indexOf('/bookmark') > -1 || v.address.indexOf('/awards') > -1 || v.address.indexOf('/external') > -1;
        if (ignore) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {}, v.title));
        }
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                href: v.address,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Thumb, {
                            url: v.icon2
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            children: v.title
                        })
                    ]
                })
            })
        }, v.title));
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(List, {
        children: [
            Items,
            Items.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                onClick: onMoveCommunity,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box, {
                    as: "button",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Thumb, {
                            url: "".concat("https://cdn.classu.co.kr", "/uploads/original/0fOCiBI7lCp3X4R6.png")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            children: "커뮤니티"
                        })
                    ]
                })
            }),
            !!userCompany && !!userCompany.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                    href: "/event/".concat(userCompany),
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Thumb, {
                                url: "https://file.classu.co.kr/biz/".concat(userCompany, "-logo.png")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                children: (0,companyConvert/* companyConvert */._)(userCompany)
                            })
                        ]
                    })
                })
            }),
            compulsory && /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                    href: "/event/plan/compulsory",
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Thumb, {
                                url: "https://file.classu.co.kr/biz/icon.png"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                children: "법정의무교육"
                            })
                        ]
                    })
                })
            })
        ]
    }));
};
var List = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-96492529-0"
})(Exhibition_templateObject());
var Item = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-96492529-1"
})(Exhibition_templateObject1(), styles/* palette.grey25 */.DG.grey25);
var Box = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-96492529-2"
})(_templateObject2());
var Thumb = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-96492529-3"
})(_templateObject3(), function(param) {
    var url = param.url;
    return "url(".concat(url, ")");
});
var Title = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-96492529-4"
})(_templateObject4(), typography/* caption3_medium */.eH, function(param) {
    var color = param.color;
    return color ? color : styles/* palette.grey080 */.DG.grey080;
});
/* harmony default export */ var main_Exhibition = (Exhibition);

// EXTERNAL MODULE: ./src/slices/event.thunk.js
var event_thunk = __webpack_require__(7026);
// EXTERNAL MODULE: ./src/hooks/common/useSwipe.js
var useSwipe = __webpack_require__(2829);
;// CONCATENATED MODULE: ./src/components/organisms/main/Banner.js





// slices

// hooks


// styles


// utils

function Banner_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Banner_templateObject() {
    var data = Banner_taggedTemplateLiteral([
        "\n  overflow: hidden;\n  position: relative;\n"
    ]);
    Banner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Banner_templateObject1() {
    var data = Banner_taggedTemplateLiteral([
        "\n  overflow: hidden;\n  display: inline-block;\n  position: relative;\n  vertical-align: top;\n  width: 100%;\n  height: 110px;\n  font-size: 0;\n  background-color: ",
        ";\n  background-image: ",
        ";\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n  transition: height 0.2s ease;\n"
    ]);
    Banner_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Banner_templateObject2() {
    var data = Banner_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  flex: 0 auto;\n  width: 100%;\n  height: 100%;\n\n  z-index: 0;\n"
    ]);
    Banner_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Banner_templateObject3() {
    var data = Banner_taggedTemplateLiteral([
        "\n  display: flex;\n  position: absolute;\n  align-items: center;\n  justify-content: center;\n  height: 22px;\n  right: 8px;\n  bottom: 8px;\n  padding: 0 8px;\n  border-radius: 12px;\n  background: rgba(0, 0, 0, 0.5);\n  ",
        "\n  color: ",
        ";\n  line-height: 0;\n\n  & > i {\n    margin: 0 2px;\n    ",
        "\n    color: inherit;\n    line-height: inherit;\n  }\n"
    ]);
    Banner_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
/**
 * 메인 스와이프 배너
 */ var Banner = function() {
    var router = (0,next_router.useRouter)();
    var dispatch = (0,useStore/* useDispatch */.I)();
    var banner = (0,useStore/* useSelector */.v)(function(state) {
        return state.event.banner;
    });
    var ref = (0,react.useState)(true), isApp = ref[0], setIsApp = ref[1];
    var ref1 = (0,useSwipe/* default */.Z)({
        items: banner
    }), currentIndex = ref1.currentIndex, currentList = ref1.currentList, Slider = ref1.Slider;
    (0,react.useEffect)(function() {
        var device = (0,deviceChecker/* default */.Z)();
        if (device.app()) {
            return setIsApp(true);
        }
        setIsApp(false);
    }, []);
    (0,react.useEffect)(function() {
        if (!router.isReady) {
            return;
        }
        if (banner.length) {
            return;
        }
        dispatch((0,event_thunk/* getEventBanner */.Ty)());
    }, [
        dispatch,
        banner.length,
        router.isReady
    ]);
    var Items = currentList.map(function(v, i) {
        // TEST
        var isExternal = v.link.indexOf('/webview/external') > -1;
        if (isExternal && isApp) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Banner_Item, {
                url: v.image,
                bgColor: v.backcolor,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                    href: v.link,
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cover, {
                        target: "_blank",
                        rel: "noopener noreferrer"
                    })
                })
            }, "".concat(v.link).concat(i)));
        }
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Banner_Item, {
            url: v.image,
            bgColor: v.backcolor,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                href: v.link,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cover, {})
            })
        }, "".concat(v.link).concat(i)));
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider, {
                children: Items
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(More, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: currentIndex
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        children: "/"
                    }),
                    banner.length
                ]
            })
        ]
    }));
};
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8e8b233e-0"
})(Banner_templateObject());
var Banner_Item = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-8e8b233e-1"
})(Banner_templateObject1(), function(param) {
    var bgColor = param.bgColor;
    return bgColor;
}, function(param) {
    var url = param.url;
    return "url(".concat(url, ")");
});
var Cover = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-8e8b233e-2"
})(Banner_templateObject2());
var More = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-8e8b233e-3"
})(Banner_templateObject3(), typography/* caption3_regular */.dK, styles/* palette.white */.DG.white, typography/* caption3_regular */.dK);
/* harmony default export */ var main_Banner = (Banner);

// EXTERNAL MODULE: ./src/components/organisms/main/ClassGridList.js + 4 modules
var ClassGridList = __webpack_require__(4739);
// EXTERNAL MODULE: ./src/components/organisms/main/Category.js
var Category = __webpack_require__(5914);
// EXTERNAL MODULE: ./src/components/molecules/class/ClassListSlider.js + 1 modules
var ClassListSlider = __webpack_require__(7991);
// EXTERNAL MODULE: ./src/components/atoms/photos/ClassCover.js
var ClassCover = __webpack_require__(450);
// EXTERNAL MODULE: ./src/components/atoms/photos/Avatar.js
var Avatar = __webpack_require__(3315);
// EXTERNAL MODULE: ./src/cds/icons/index.tsx
var icons = __webpack_require__(6643);
;// CONCATENATED MODULE: ./src/components/molecules/class/card/RegisteredItem.js




// components


// styles



function RegisteredItem_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function RegisteredItem_templateObject() {
    var data = RegisteredItem_taggedTemplateLiteral([
        "\n  display: block;\n  cursor: pointer;\n  border-radius: 8px;\n"
    ]);
    RegisteredItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RegisteredItem_templateObject1() {
    var data = RegisteredItem_taggedTemplateLiteral([
        "\n  position: relative;\n  flex: 0 0 auto;\n  width: 100%;\n  margin-right: 12px;\n\n  svg {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    margin-top: -20px;\n    margin-left: -20px;\n    z-index: 0;\n\n    ",
        " {\n      width: 56px;\n      height: 56px;\n      margin-top: -28px;\n      margin-left: -28px;\n    }\n  }\n"
    ]);
    RegisteredItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RegisteredItem_templateObject2() {
    var data = RegisteredItem_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: flex-start;\n  margin-top: 8px;\n\n  & > div:first-of-type {\n    display: none;\n    flex: 0 auto;\n    width: 32px;\n    padding: 4px 0 0;\n    margin: 0 12px 0 0;\n  }\n\n  & > div:last-of-type {\n    overflow: hidden;\n    flex: 1 auto;\n  }\n\n  ",
        " {\n    & > div:first-of-type {\n      display: block;\n    }\n  }\n"
    ]);
    RegisteredItem_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function RegisteredItem_templateObject3() {
    var data = RegisteredItem_taggedTemplateLiteral([
        "\n  flex: 0 auto;\n  width: 32px;\n  height: 32px;\n"
    ]);
    RegisteredItem_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function RegisteredItem_templateObject4() {
    var data = RegisteredItem_taggedTemplateLiteral([
        "\n  position: relative;\n  margin: 8px 0 2px;\n  ",
        "\n  color: ",
        ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  word-wrap: normal;\n\n  ",
        " {\n    margin: 0 0 2px;\n    font-size: 15px;\n  }\n"
    ]);
    RegisteredItem_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = RegisteredItem_taggedTemplateLiteral([
        "\n  display: block;\n  margin-bottom: 6px;\n  ",
        "\n  color: ",
        ";\n\n  ",
        " {\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = RegisteredItem_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-bottom: 8px;\n\n  span {\n    display: flex;\n    align-items: center;\n    flex: 0 auto;\n    ",
        "\n    color: ",
        ";\n    font-weight: 350 !important;\n\n    & ~ span {\n      &::before {\n        display: inline-block;\n        content: '';\n        width: 2px;\n        height: 2px;\n        border-radius: 100%;\n        background-color: currentColor;\n        margin: 0 4px;\n      }\n    }\n\n    i {\n      margin-left: 4px;\n      ",
        "\n      font-style: initial;\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = RegisteredItem_taggedTemplateLiteral([
        "\n  overflow: hidden;\n  position: relative;\n  width: 95%;\n  height: 2px;\n  margin-bottom: 12px;\n  border-radius: 1px;\n  background-color: ",
        ";\n\n  &::before {\n    display: block;\n    content: '';\n    position: absolute;\n    width: ",
        ";\n    height: 100%;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    border-radius: 1px;\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = RegisteredItem_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-bottom: 8px;\n\n  span {\n    display: flex;\n    align-items: center;\n    flex: 0 auto;\n    height: 24px;\n    padding: 0 8px;\n    border-radius: 2px;\n    background-color: ",
        ";\n    ",
        "\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
/**
 * 메인 - 관심클래스 카드
 * @param {object} props
 * @param {import('types/slices/main').RecommendClass} props.data 클래스 정보
 */ var RegisteredItem = function(param) {
    var data = param.data;
    var router = (0,next_router.useRouter)();
    var hrefInfix = data.community.open === 'Y' ? "/community/".concat(data.community.id) : data.class_study_status === 'Y' ? "/class/lecture/".concat(data.class_id) : "/class/wait/".concat(data.class_id);
    var onProfile = function(e) {
        e.preventDefault();
        router.push("/user/".concat(data.coach_id));
    };
    var onMouseDownAvatar = function(e) {
        if (e.buttons === 4) {
            e.stopPropagation();
            window.open("".concat("https://www.classu.co.kr", "/new/user/").concat(data.coach_id), '_blank');
        }
    };
    var enterCommunity = function(id) {
        window.location.href = "https://classu.co.kr/community/".concat(id);
    };
    var enterClass = function(id) {
        window.location.href = "https://classu.co.kr/class/lecture/".concat(id);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
            href: "".concat("https://www.classu.co.kr").concat(hrefInfix),
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RegisteredItem_Item, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Thumbnail, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassCover/* default */.Z, {
                                src: data.photo,
                                alt: data.class_name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                name: "ic_play_circle",
                                width: 40,
                                height: 40
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Info, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarButton, {
                                    onClick: onProfile,
                                    onMouseDown: onMouseDownAvatar,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                        width: 32,
                                        height: 32,
                                        src: data.coach_photo
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisteredItem_Title, {
                                        children: data.class_name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Coach, {
                                        children: data.coach_name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Status, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    "진도율",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("i", {
                                                        children: [
                                                            data.progress_rate,
                                                            "%"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    "주간미션",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("i", {
                                                        children: [
                                                            data.my_mission_per,
                                                            "%"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Progress, {
                                        gauge: "".concat(data.my_mission_per, "%")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Remain, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: data.class_study_status === 'Y' ? data.end_date_info : data.class_open_date_text
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    }));
};
var RegisteredItem_Item = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-698e4183-0"
})(RegisteredItem_templateObject());
var Thumbnail = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-698e4183-1"
})(RegisteredItem_templateObject1(), styles/* mediaQuery.large */.cy.large);
var Info = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-698e4183-2"
})(RegisteredItem_templateObject2(), styles/* mediaQuery.medium */.cy.medium);
var AvatarButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-698e4183-3"
})(RegisteredItem_templateObject3());
var RegisteredItem_Title = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-698e4183-4"
})(RegisteredItem_templateObject4(), typography/* subtitle4_medium */.b_, styles/* palette.grey75 */.DG.grey75, styles/* mediaQuery.large */.cy.large);
var Coach = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-698e4183-5"
})(_templateObject5(), typography/* caption2_regular */.Ug, styles/* palette.grey0 */.DG.grey0, styles/* mediaQuery.large */.cy.large);
var Status = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-698e4183-6"
})(_templateObject6(), typography/* caption2_medium */.pn, styles/* palette.grey75 */.DG.grey75, typography/* caption2_medium */.pn, styles/* palette.red040 */.DG.red040);
var Progress = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-698e4183-7"
})(_templateObject7(), styles/* palette.system.BNB */.DG.system.BNB, function(param) {
    var gauge = param.gauge;
    return gauge;
}, styles/* palette.red040 */.DG.red040);
var Remain = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-698e4183-8"
})(_templateObject8(), styles/* palette.BTN.BG */.DG.BTN.BG, typography/* caption3_medium */.eH, styles/* palette.grey75 */.DG.grey75);
/* harmony default export */ var card_RegisteredItem = (RegisteredItem);

// EXTERNAL MODULE: ./src/components/molecules/common/HorizontalScrollSlider.js + 1 modules
var HorizontalScrollSlider = __webpack_require__(1291);
;// CONCATENATED MODULE: ./src/components/molecules/class/RegisteredListSlider.js


// components


/**
 * 수강 중인 클래스
 * @param {object} param
 * @param {object[]} param.list
 * @param {object[]} param.sliderPerView
 */ var RegisteredListSlider = function(param) {
    var _list = param.list, list = _list === void 0 ? [] : _list, slidePerView = param.slidePerView;
    var sliderRef = (0,react.useRef)(null);
    var Items = list.map(function(v) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalScrollSlider/* Slide */.M, {
            slidePerView: slidePerView,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card_RegisteredItem, {
                data: v
            })
        }, v.class_id));
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalScrollSlider/* default */.Z, {
        ref: sliderRef,
        list: list,
        item: Items
    }));
};
/* harmony default export */ var class_RegisteredListSlider = (RegisteredListSlider);

// EXTERNAL MODULE: ./src/cds/layout/Main.tsx
var Main = __webpack_require__(3475);
// EXTERNAL MODULE: ./src/components/layout/index.js + 2 modules
var layout = __webpack_require__(9809);
// EXTERNAL MODULE: ./src/slices/main.thunk.js
var main_thunk = __webpack_require__(1258);
// EXTERNAL MODULE: ./src/hooks/common/useModal.js + 4 modules
var useModal = __webpack_require__(5042);
// EXTERNAL MODULE: ./src/lib/utils/helper.js
var helper = __webpack_require__(4058);
// EXTERNAL MODULE: ./src/lib/utils/format/number.js
var number = __webpack_require__(4593);
// EXTERNAL MODULE: ./src/lib/utils/condition.js
var condition = __webpack_require__(873);
// EXTERNAL MODULE: ./src/hooks/dataMining/useDataMining.js + 5 modules
var useDataMining = __webpack_require__(9648);
;// CONCATENATED MODULE: ./pages/index.js





// components









// slices


// hooks


// import useCommonBridge from 'hooks/bridge/useCommonBridge';
// utils



// styles





function pages_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function pages_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return pages_arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function pages_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function pages_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || pages_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function pages_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function pages_toConsumableArray(arr) {
    return pages_arrayWithoutHoles(arr) || pages_iterableToArray(arr) || pages_unsupportedIterableToArray(arr) || pages_nonIterableSpread();
}
function pages_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return pages_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return pages_arrayLikeToArray(o, minLen);
}
function pages_templateObject() {
    var data = pages_taggedTemplateLiteral([
        "\n  width: 100%;\n  background-color: ",
        ";\n  padding-bottom: 64px;\n\n  ",
        " {\n    padding-bottom: 100px;\n  }\n"
    ]);
    pages_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function pages_templateObject1() {
    var data = pages_taggedTemplateLiteral([
        "\n  display: none;\n  background-color: ",
        ";\n\n  ",
        " {\n    display: block;\n  }\n"
    ]);
    pages_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function pages_templateObject2() {
    var data = pages_taggedTemplateLiteral([
        "\n  padding-top: 24px;\n  background-color: ",
        ";\n  ",
        " {\n    width: 1800px;\n    max-width: 100%;\n    padding: 48px 32px;\n    margin: 48px auto;\n  }\n  ",
        " {\n    padding: 48px 72px;\n  }\n"
    ]);
    pages_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function pages_templateObject3() {
    var data = pages_taggedTemplateLiteral([
        "\n  height: 56px;\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    pages_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function pages_templateObject4() {
    var data = pages_taggedTemplateLiteral([
        "\n  padding: 0 16px;\n  margin: 0 0 20px;\n  ",
        "\n  color: ",
        ";\n  transition: font-size 0.2s ease;\n\n  span {\n    display: block;\n  }\n\n  a {\n    color: ",
        ";\n  }\n\n  ",
        " {\n    font-size: 18px;\n    padding: 0;\n    margin: 0 0 16px;\n\n    span {\n      display: inline-block;\n\n      & ~ span {\n        margin-left: 6px;\n      }\n    }\n  }\n"
    ]);
    pages_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function pages_templateObject5() {
    var data = pages_taggedTemplateLiteral([
        "\n  height: 10px;\n  margin: 32px 0 24px;\n  border: none;\n  background-color: ",
        ";\n\n  ",
        " {\n    height: 1px;\n    margin: 48px 0;\n    background-color: ",
        ";\n    border-color: ",
        ";\n    border-style: solid;\n    border-width: 1px 0 0 0;\n  }\n\n  &:last-of-type {\n    ",
        " {\n      display: none;\n    }\n  }\n"
    ]);
    pages_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function pages_templateObject6() {
    var data = pages_taggedTemplateLiteral([
        "\n  margin: 20px 0;\n\n  ",
        " {\n    display: none;\n\n    & + ",
        " {\n      display: none;\n    }\n  }\n"
    ]);
    pages_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function pages_templateObject7() {
    var data = pages_taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n\n  ",
        " {\n    background-color: ",
        ";\n  }\n\n  & > div {\n    padding: 24px 0 32px;\n\n    ",
        " {\n      width: 1800px;\n      max-width: 100%;\n      padding: 24px 32px 32px;\n      margin: 0 auto;\n    }\n\n    ",
        " {\n      padding: 24px 72px 32px;\n    }\n  }\n"
    ]);
    pages_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function pages_templateObject8() {
    var data = pages_taggedTemplateLiteral([
        "\n  margin: 32px 0 24px 0;\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    pages_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = pages_taggedTemplateLiteral([
        "\n  overflow: hidden;\n  display: none;\n  padding: 30px 24px;\n  margin: 48px 0;\n  border-radius: 8px;\n  background-color: ",
        ";\n  text-align: center;\n\n  ",
        " {\n    display: block;\n  }\n\n  h2 {\n    margin-bottom: 16px;\n    color: ",
        ";\n    font-size: 26px;\n    font-weight: 700;\n    line-height: 36px;\n  }\n\n  p {\n    color: ",
        ";\n    ",
        "\n    word-break: keep-all;\n  }\n\n  strong {\n    position: relative;\n    color: ",
        ";\n    ",
        "\n\n    &::after {\n      display: block;\n      content: '';\n      position: absolute;\n      width: 100%;\n      height: 1px;\n      bottom: -2px;\n      left: 0;\n      background-color: currentColor;\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = pages_taggedTemplateLiteral([
        "\n  ",
        " {\n    margin-top: 80px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
/**
 * 랜덤 숫자를 리턴합니다.
 * @param {object} props
 * @param {number} props.max
 * @returns
 */ var getRandomNumber = function(param) {
    var max = param.max;
    return Math.floor(Math.random() * max);
};
/**
 * 메인 페이지
 */ var MainPage = function() {
    var ref = (0,useStore/* useSelector */.v)(function(param) {
        var search = param.search, main = param.main, user = param.user;
        return {
            keywordInfo: search.keywordRankList,
            recentClassInfo: user.recentClassList,
            famousClassInfo: main.keywordRecommend.recom_list,
            marketingLowPriceInfo: main.eventRecommend.recom_list,
            recomClassInfo: main.recommendClassList,
            userId: user.info.id
        };
    }), userId = ref.userId, keywordInfo = ref.keywordInfo, marketingLowPriceInfo = ref.marketingLowPriceInfo, famousClassInfo = ref.famousClassInfo, recentClassInfo = ref.recentClassInfo, recomClassInfo = ref.recomClassInfo;
    var ref1 = (0,react.useState)({}), subscribeList = ref1[0], setSubScribeList = ref1[1];
    (0,react.useEffect)(function() {
        if (!userId) {
            setSubScribeList(function(prev) {
                return _objectSpread({}, prev, {
                    keywordInfo: keywordInfo,
                    marketingLowPriceInfo: marketingLowPriceInfo,
                    famousClassInfo: famousClassInfo,
                    recomClassInfo: recomClassInfo
                });
            });
            return;
        }
        setSubScribeList(function(prev) {
            return _objectSpread({}, prev, {
                keywordInfo: keywordInfo,
                marketingLowPriceInfo: marketingLowPriceInfo,
                famousClassInfo: famousClassInfo,
                recentClassInfo: recentClassInfo,
                recomClassInfo: recomClassInfo
            });
        });
    }, [
        keywordInfo,
        marketingLowPriceInfo,
        famousClassInfo,
        recentClassInfo,
        recomClassInfo,
        userId, 
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0,condition/* isInBrowser */.L)() && (0,useDataMining/* useDataMining */.XT)({
        subscribeList: subscribeList
    });
    var router = (0,next_router.useRouter)();
    var dispatch = (0,useStore/* useDispatch */.I)();
    var ref2 = _slicedToArray((0,useStore/* useSelector */.v)(function(state) {
        return [
            state.event.eventList,
            state.event.banner
        ];
    }), 2), planEvent = ref2[0], bannerList = ref2[1];
    var ref3 = _slicedToArray((0,useStore/* useSelector */.v)(function(state) {
        return [
            state.user.info,
            state.user.classList.registered,
            state.user.recentClassList, 
        ];
    }), 3), userInfo = ref3[0], registeredClassList = ref3[1], recentClassList = ref3[2];
    var ref4 = _slicedToArray((0,useStore/* useSelector */.v)(function(state) {
        return [
            state.main.serviceInfo,
            state.main.recommendClassList,
            state.main.eventRecommend.recom_list,
            state.main.keywordRecommend.keyword,
            state.main.keywordRecommend.keyword_type,
            state.main.keywordRecommend.recom_list, 
        ];
    }), 6), serviceInfo = ref4[0], recommendClassList = ref4[1], eventRecommendClassList = ref4[2], keyword = ref4[3], keywordType = ref4[4], keywordRecommendClassList = ref4[5];
    var ref5 = (0,react.useState)(false), isIpadApp = ref5[0], setIsIpadApp = ref5[1];
    var ref6 = (0,react.useState)([]), dealClassList = ref6[0], setDealClassList = ref6[1];
    var ref7 = (0,react.useState)([]), recomnClass = ref7[0], setRecomnClass = ref7[1];
    var initModal = (0,useModal/* default */.Z)().initModal;
    // const { onOutLinkForBrowser } = useCommonBridge();
    // const onOpenOutBrowser = () => {
    //   const url = `${process.env.NEXT_PUBLIC_DEFAULT_HOST}/app_search`;
    //   onOutLinkForBrowser({ url });
    // };
    /** ipadApp 여부 확인 */ (0,react.useEffect)(function() {
        var device = (0,deviceChecker/* default */.Z)();
        setIsIpadApp(device.iPadApp());
    }, []);
    /** 초저가 클래스 호출 */ (0,react.useEffect)(function() {
        if (isIpadApp) {
            return;
        }
        if (!userInfo.isLoaded || eventRecommendClassList.length) {
            return;
        }
        dispatch((0,main_thunk/* getEventClassList */.JO)({
            userId: userInfo.id
        }));
    }, [
        dispatch,
        userInfo,
        eventRecommendClassList.length,
        isIpadApp
    ]);
    /** 키워드 클래스 호출 */ (0,react.useEffect)(function() {
        if (isIpadApp) {
            return;
        }
        if (userInfo.isLoaded && !keywordRecommendClassList.length) {
            dispatch((0,main_thunk/* getKeywordClassList */.Gs)({
                userId: userInfo.id
            }));
        }
    }, [
        dispatch,
        userInfo,
        keywordRecommendClassList.length,
        isIpadApp
    ]);
    /** 최근 본 클래스 호출 */ (0,react.useEffect)(function() {
        if (isIpadApp) {
            return;
        }
        if (userInfo.isLoaded && userInfo.id) {
            dispatch((0,user_thunk/* getRecentClassList */.n4)({
                userId: userInfo.id
            }));
        }
    }, [
        dispatch,
        isIpadApp,
        userInfo
    ]);
    /** 추천 클래스 호출 */ (0,react.useEffect)(function() {
        if (isIpadApp) {
            return;
        }
        if (userInfo.isLoaded && !recommendClassList.length) {
            dispatch((0,main_thunk/* getMainClassList */.PL)({
                userId: userInfo.id
            }));
        }
    }, [
        dispatch,
        userInfo,
        recommendClassList.length,
        isIpadApp
    ]);
    /** 초저가 클래스에 배너 무조건 0번 인덱스에 넣기 */ (0,react.useEffect)(function() {
        if (!eventRecommendClassList.length) {
            return;
        }
        if (!bannerList.length) {
            return setDealClassList(eventRecommendClassList);
        }
        var n = getRandomNumber({
            max: bannerList.length
        });
        while(/event/.test(bannerList[n].link) === false || /event\/plan\/1/.test(bannerList[n].link)){
            n = getRandomNumber({
                max: bannerList.length
            });
        }
        var banner = Object.assign({}, bannerList[n]);
        banner.link = banner.link.replace(/https?:\/\/\www\.classu\.co\.kr/gim, "https://www.classu.co.kr");
        var newList = [
            banner
        ].concat(pages_toConsumableArray(eventRecommendClassList));
        setDealClassList(newList);
    }, [
        bannerList,
        eventRecommendClassList
    ]);
    /** 추천 클래스에 배너 랜덤 인덱스에 넣기 */ (0,react.useEffect)(function() {
        if (!recommendClassList.length) {
            return;
        }
        if (!bannerList.length) {
            return setRecomnClass(recommendClassList);
        }
        var n = getRandomNumber({
            max: recommendClassList.length + 1
        });
        var newList = pages_toConsumableArray(recommendClassList);
        var banner = Object.assign({}, bannerList[1]);
        banner.link = banner.link.replace(/https?:\/\/\www\.classu\.co\.kr/gim, "https://www.classu.co.kr");
        newList.splice(n, 1, banner);
        setRecomnClass(newList);
    }, [
        bannerList,
        isIpadApp,
        recommendClassList
    ]);
    /** 서비스 정보 호출 */ (0,react.useEffect)(function() {
        if (!router.isReady) {
            return;
        }
        if (isIpadApp) {
            return;
        }
        dispatch((0,main_thunk/* getServiceInfo */.wi)());
    }, [
        dispatch,
        isIpadApp,
        router.isReady
    ]);
    /** 추가정보 입력 모달 */ (0,react.useEffect)(function() {
        if (!userInfo.isShowRequirementModal) {
            return;
        }
        initModal({
            name: 'RequirementInfo'
        });
    }, [
        userInfo,
        initModal
    ]);
    /** 인기 클래스 키워드 저장 */ (0,react.useEffect)(function() {
        dispatch((0,dataMining/* setFamousClassKeyword */.Ab)("".concat(keyword)));
    }, [
        dispatch,
        keyword,
        keywordInfo
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(pages_Wrapper, {
            children: [
                !isIpadApp && /*#__PURE__*/ (0,jsx_runtime.jsx)(TagWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(main_PopularityTagList, {})
                }),
                !isIpadApp && /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeArea, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ExhibitionWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(main_Exhibition, {
                        list: planEvent
                    })
                }),
                registeredClassList.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisteredWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_Title, {
                                children: "수강 중인 클래스"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(class_RegisteredListSlider, {
                                list: registeredClassList,
                                slidePerView: [
                                    {
                                        break: 'default',
                                        view: 2.04
                                    },
                                    {
                                        break: styles/* mediaValue.small */.T8.small,
                                        view: 3.04
                                    },
                                    {
                                        break: styles/* mediaValue.large */.T8.large,
                                        view: 3
                                    },
                                    {
                                        break: 1480,
                                        view: 4
                                    },
                                    {
                                        break: 1900,
                                        view: 5
                                    }, 
                                ]
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Divide, {}),
                !isIpadApp && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
                    children: [
                        !!dealClassList.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                userInfo.id && /*#__PURE__*/ (0,jsx_runtime.jsxs)(pages_Title, {
                                    children: [
                                        userInfo.name,
                                        "님을 위한 오늘의 초저가 클래스"
                                    ]
                                }),
                                !userInfo.id && /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_Title, {
                                    children: "오늘의 초저가 클래스"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassListSlider/* default */.Z, {
                                    list: dealClassList,
                                    showSalePer: true,
                                    showPrice: true,
                                    slidePerView: [
                                        {
                                            break: 'default',
                                            view: 1.4
                                        },
                                        {
                                            break: styles/* mediaValue.small */.T8.small,
                                            view: 2.4
                                        },
                                        {
                                            break: styles/* mediaValue.large */.T8.large,
                                            view: 3
                                        },
                                        {
                                            break: 1480,
                                            view: 4
                                        },
                                        {
                                            break: 1900,
                                            view: 5
                                        }, 
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(main_Banner, {})
                        }),
                        !(0,helper/* isEmptyObject */.Qr)(serviceInfo) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ServiceInfoBanner, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: "커뮤니티형 온라인 강의 플랫폼"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                            children: [
                                                (0,number/* formatToPrice */.t)(serviceInfo.total_curriculum_cnt),
                                                "개"
                                            ]
                                        }),
                                        " 강의에서",
                                        ' ',
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                            children: [
                                                (0,number/* formatToPrice */.t)(serviceInfo.total_community_cnt),
                                                "개"
                                            ]
                                        }),
                                        "의 수강 활동을 통해 배움을 즐겁게 만들어 가고 있습니다."
                                    ]
                                })
                            ]
                        }),
                        keywordRecommendClassList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                keywordType === 'user_history' && /*#__PURE__*/ (0,jsx_runtime.jsxs)(pages_Title, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                "검색하신",
                                                ' ',
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                    href: "/search?keyword=".concat(keyword),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        children: keyword
                                                    })
                                                }),
                                                "에"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "관련된 인기 클래스예요."
                                        })
                                    ]
                                }),
                                keywordType === 'search_rank' && /*#__PURE__*/ (0,jsx_runtime.jsxs)(pages_Title, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                "인기검색어 ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                    href: "/search?keyword=".concat(keyword),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        children: keyword
                                                    })
                                                }),
                                                "에"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "관련된 인기 클래스예요."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassListSlider/* default */.Z, {
                                    list: keywordRecommendClassList,
                                    slidePerView: [
                                        {
                                            break: 'default',
                                            view: 2.04
                                        },
                                        {
                                            break: styles/* mediaValue.small */.T8.small,
                                            view: 3.04
                                        },
                                        {
                                            break: styles/* mediaValue.large */.T8.large,
                                            view: 3
                                        },
                                        {
                                            break: 1480,
                                            view: 4
                                        },
                                        {
                                            break: 1900,
                                            view: 5
                                        }, 
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divide, {})
                            ]
                        }),
                        userInfo.id && recentClassList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_Title, {
                                    children: "최근 본 클래스"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassListSlider/* default */.Z, {
                                    list: recentClassList,
                                    slidePerView: [
                                        {
                                            break: 'default',
                                            view: 2.04
                                        },
                                        {
                                            break: styles/* mediaValue.small */.T8.small,
                                            view: 3.04
                                        },
                                        {
                                            break: styles/* mediaValue.large */.T8.large,
                                            view: 3
                                        },
                                        {
                                            break: 1480,
                                            view: 4
                                        },
                                        {
                                            break: 1900,
                                            view: 5
                                        }, 
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divide, {})
                            ]
                        }),
                        userInfo.id && /*#__PURE__*/ (0,jsx_runtime.jsxs)(pages_Title, {
                            children: [
                                userInfo.name,
                                "님을 위한 추천 클래스"
                            ]
                        }),
                        !userInfo.id && /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_Title, {
                            children: "추천 클래스"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassGridList/* default */.Z, {
                            list: recomnClass,
                            slidePerView: [
                                {
                                    break: 'default',
                                    view: 1
                                },
                                {
                                    break: styles/* mediaValue.small */.T8.small,
                                    view: 2
                                },
                                {
                                    break: styles/* mediaValue.medium */.T8.medium,
                                    view: 3
                                },
                                {
                                    break: 1480,
                                    view: 4
                                },
                                {
                                    break: 1900,
                                    view: 5
                                }, 
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divide, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryListWrapper, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_Title, {
                                    children: "찾고 있는 클래스가 있나요?"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Category/* default */.Z, {})
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};
MainPage.getLayout = function getLayout(page) {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* default */.Z, {
        children: page
    }));
};
var pages_Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Main/* default */.Z).withConfig({
    componentId: "sc-b4d17bac-0"
})(pages_templateObject(), styles/* palette.system.BG */.DG.system.BG, styles/* mediaQuery.xlarge */.cy.xlarge);
var TagWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b4d17bac-1"
})(pages_templateObject1(), styles/* palette.system.BG */.DG.system.BG, styles/* mediaQuery.large */.cy.large);
var ContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b4d17bac-2"
})(pages_templateObject2(), styles/* palette.system.BG */.DG.system.BG, styles/* mediaQuery.large */.cy.large, styles/* mediaQuery.xlarge */.cy.xlarge);
var SafeArea = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b4d17bac-3"
})(pages_templateObject3(), styles/* mediaQuery.large */.cy.large);
var pages_Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-b4d17bac-4"
})(pages_templateObject4(), typography/* subtitle3_bold */.Zl, styles/* palette.grey100 */.DG.grey100, styles/* palette.blue070 */.DG.blue070, styles/* mediaQuery.large */.cy.large);
var Divide = styled_components_browser_esm/* default.hr.withConfig */.ZP.hr.withConfig({
    componentId: "sc-b4d17bac-5"
})(pages_templateObject5(), styles/* palette.system.Null */.DG.system.Null, styles/* mediaQuery.large */.cy.large, styles/* palette.background.grey030 */.DG.background.grey030, styles/* palette.system.grey */.DG.system.grey, styles/* mediaQuery.large */.cy.large);
var ExhibitionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b4d17bac-6"
})(pages_templateObject6(), styles/* mediaQuery.large */.cy.large, Divide);
var RegisteredWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b4d17bac-7"
})(pages_templateObject7(), styles/* palette.system.BLACK */.DG.system.BLACK, styles/* mediaQuery.large */.cy.large, styles/* palette.system.BLACK */.DG.system.BLACK, styles/* mediaQuery.large */.cy.large, styles/* mediaQuery.xlarge */.cy.xlarge);
var BannerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b4d17bac-8"
})(pages_templateObject8(), styles/* mediaQuery.large */.cy.large);
var ServiceInfoBanner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b4d17bac-9"
})(_templateObject9(), styles/* palette.system.BNB */.DG.system.BNB, styles/* mediaQuery.large */.cy.large, styles/* palette.grey75 */.DG.grey75, styles/* palette.grey50 */.DG.grey50, typography/* body1_regular */.nn, styles/* palette.Primary.Active */.DG.Primary.Active, typography/* subtitle3_medium */.iD);
var CategoryListWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b4d17bac-10"
})(_templateObject10(), styles/* mediaQuery.large */.cy.large);
/* harmony default export */ var pages = (MainPage);


/***/ }),

/***/ 5914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(7379);
/* harmony import */ var cds_buttons_Outline__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5472);
/* harmony import */ var cds_buttons_Fill__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5549);
/* harmony import */ var cds_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6643);
/* harmony import */ var hooks_common_useStore__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8004);
/* harmony import */ var hooks_common_useSearchModal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4970);
/* harmony import */ var lib_utils_deviceChecker__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7496);
/* harmony import */ var lib_utils_array__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8224);
/* harmony import */ var cds_typography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(506);
/* harmony import */ var cds_styles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3887);
/* harmony import */ var slices_dataMining__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7990);




// components



// hooks


// utils


// styles



function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  overflow: hidden;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  padding: 0 32px;\n  margin-left: -16px;\n  font-size: 0;\n  white-space: nowrap;\n\n  & > div:first-of-type {\n    display: block;\n  }\n\n  & > div:last-of-type {\n    display: none;\n  }\n\n  ",
        " {\n    padding: 0 0;\n    margin-left: -20px;\n    white-space: normal;\n\n    & > div:first-of-type {\n      display: none;\n    }\n\n    & > div:last-of-type {\n      display: block;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  overflow: hidden;\n  display: inline-block;\n  width: calc(100% / 4);\n  padding-left: 16px;\n  transition: width 0.2s ease, padding 0.2s ease, margin 0.2s ease;\n  vertical-align: top;\n  ",
        " {\n    width: calc(100% / 5);\n  }\n  ",
        " {\n    width: calc(100% / 6);\n  }\n  ",
        " {\n    padding-left: 20px;\n    margin-bottom: 20px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n  ",
        " {\n    display: inline-block;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  ",
        " {\n    height: 64px;\n    border-radius: 4px;\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  overflow: hidden;\n  flex: 0 auto;\n  width: 100%;\n  height: 0;\n  padding-bottom: 100%;\n  border-radius: 4px;\n  margin: 0 auto 6px;\n  background-color: transparent;\n  background-image: ",
        ";\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  ",
        "\n  color: ",
        ";\n  text-align: center;\n  word-break: keep-all;\n  svg {\n    position: relative;\n    top: 1px;\n    margin-right: 4px;\n  }\n  img {\n    display: none;\n    width: 18px;\n    max-width: 100%;\n    margin-right: 6px;\n    filter: brightness(0) invert(1) grayscale(100%);\n  }\n  ",
        " {\n    ",
        "\n    & > img {\n      display: block;\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  width: calc(100% - 32px);\n  padding: 0 16px;\n  margin: 16px 16px 0;\n  ",
        "\n  color: ",
        ";\n  ",
        " {\n    display: none;\n  }\n  background-color: ",
        ";\n  border: none;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
/**
 * 커버 이미지를 포함한 카테고리 리스트
 */ var Category = function() {
    var categoryList = (0,hooks_common_useStore__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v)(function(state) {
        return state.category.categoryList;
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isIpadApp = ref[0], setIsIpadApp = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), shuffledList = ref1[0], setShuffledList = ref1[1];
    var isShuffled = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
    var onOpenSearch = (0,hooks_common_useSearchModal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)().onOpenSearch;
    // ipadApp check
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var device = (0,lib_utils_deviceChecker__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)();
        setIsIpadApp(device.iPadApp());
    }, []);
    /** 셔플 초기 한 번만 동작하기 */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isIpadApp) {
            return;
        }
        var already = !categoryList.length || shuffledList.length || isShuffled.current;
        if (already) {
            return;
        }
        setShuffledList((0,lib_utils_array__WEBPACK_IMPORTED_MODULE_12__/* .getShuffledArray */ .y)(categoryList));
        isShuffled.current = true;
    }, [
        categoryList,
        isIpadApp,
        shuffledList,
        shuffledList.length
    ]);
    var dispatch = (0,hooks_common_useStore__WEBPACK_IMPORTED_MODULE_6__/* .useDispatch */ .I)();
    var onClickItem = function(e) {
        dispatch((0,slices_dataMining__WEBPACK_IMPORTED_MODULE_10__/* .setClickedItems */ .KB)({
            innerText: e.target.textContent,
            elementType: 'tagLink'
        }));
    };
    var Items = shuffledList.map(function(v) {
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Item, {
            onClick: onClickItem,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                href: "/category?categoryId=".concat(v.category),
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Box, {
                    as: "a",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Thumb, {
                            url: v.photo
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Title, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: v.icon,
                                    alt: ""
                                }),
                                v.category
                            ]
                        })
                    ]
                })
            })
        }, v.category);
    });
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(List, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: Items.slice(0, 4)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            Items,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AllItem, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                    href: "/search?keyword=",
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Box, {
                                        as: "a",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Title, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_icons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                    name: "ic_number_sign_s",
                                                    width: 14,
                                                    height: 14,
                                                    stroke: cds_styles__WEBPACK_IMPORTED_MODULE_9__/* .palette.white */ .DG.white
                                                }),
                                                "전체보기"
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MoreLink, {
                size: "44px",
                color: cds_styles__WEBPACK_IMPORTED_MODULE_9__/* .palette.grey050 */ .DG.grey050,
                onClick: onOpenSearch,
                children: "카테고리 모두 보기"
            })
        ]
    }));
};
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_13__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-38cc3f5-0"
})(_templateObject());
var List = styled_components__WEBPACK_IMPORTED_MODULE_13__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-38cc3f5-1"
})(_templateObject1(), cds_styles__WEBPACK_IMPORTED_MODULE_9__/* .mediaQuery.large */ .cy.large);
var Item = styled_components__WEBPACK_IMPORTED_MODULE_13__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    componentId: "sc-38cc3f5-2"
})(_templateObject2(), cds_styles__WEBPACK_IMPORTED_MODULE_9__/* .mediaQuery.small */ .cy.small, cds_styles__WEBPACK_IMPORTED_MODULE_9__/* .mediaQuery.medium */ .cy.medium, cds_styles__WEBPACK_IMPORTED_MODULE_9__/* .mediaQuery.large */ .cy.large);
var AllItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP)(Item).withConfig({
    componentId: "sc-38cc3f5-3"
})(_templateObject3(), cds_styles__WEBPACK_IMPORTED_MODULE_9__/* .mediaQuery.large */ .cy.large);
var Box = (0,styled_components__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP)(cds_buttons_Fill__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-38cc3f5-4"
})(_templateObject4(), cds_styles__WEBPACK_IMPORTED_MODULE_9__/* .mediaQuery.large */ .cy.large, cds_styles__WEBPACK_IMPORTED_MODULE_9__/* .palette.BTN.BG */ .DG.BTN.BG);
var Thumb = styled_components__WEBPACK_IMPORTED_MODULE_13__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-38cc3f5-5"
})(_templateObject5(), function(param) {
    var url = param.url;
    return "url(".concat(url, ")");
}, cds_styles__WEBPACK_IMPORTED_MODULE_9__/* .mediaQuery.large */ .cy.large);
var Title = styled_components__WEBPACK_IMPORTED_MODULE_13__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-38cc3f5-6"
})(_templateObject6(), cds_typography__WEBPACK_IMPORTED_MODULE_8__/* .caption2_medium */ .pn, cds_styles__WEBPACK_IMPORTED_MODULE_9__/* .palette.grey75 */ .DG.grey75, cds_styles__WEBPACK_IMPORTED_MODULE_9__/* .mediaQuery.large */ .cy.large, cds_typography__WEBPACK_IMPORTED_MODULE_8__/* .body2_regular */ .Tk);
var MoreLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP)(cds_buttons_Outline__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-38cc3f5-7"
})(_templateObject7(), cds_typography__WEBPACK_IMPORTED_MODULE_8__/* .body2_regular */ .Tk, cds_styles__WEBPACK_IMPORTED_MODULE_9__/* .palette.grey50 */ .DG.grey50, cds_styles__WEBPACK_IMPORTED_MODULE_9__/* .mediaQuery.large */ .cy.large, cds_styles__WEBPACK_IMPORTED_MODULE_9__/* .palette.BTN.BG */ .DG.BTN.BG);
/* harmony default export */ __webpack_exports__["Z"] = (Category);


/***/ }),

/***/ 2829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7379);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var lib_utils_format_time__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(508);



// utils

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 100%;\n  white-space: nowrap;\n  cursor: pointer;\n\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n  &::-webkit-scrollbar {\n    display: none;\n    width: 0;\n    background-color: transparent;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
// TODO 끝에서 시작지점으로 루틴 제거 옵셔널 추가
// TODO 최적화 여지 확인하기
/**
 * 스와이프 Hook
 *
 * @param {object} props
 * @param {any[]} props.items
 * @param {number} props.startIndex
 * @param {Function} props.prevCallback
 * @param {Function} props.nextCallback
 *
 * @example
 * const {
 *   currentIndex,
 *   currentList,
 *   Slider,
 *   onPrev,
 *   onNext
 * } = useSwipe({
 *   items: [1, 2, 3, ... ],
 *   startIndex: 0,
 *   () => { ... },
 *   () => { ... } }
 * );
 */ var useSwipe = function(param1) {
    var items = param1.items, _startIndex = param1.startIndex, startIndex = _startIndex === void 0 ? 0 : _startIndex, prevCallback = param1.prevCallback, nextCallback = param1.nextCallback;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), list = ref[0], setList = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1), idx = ref1[0], setIdx = ref1[1];
    var slider = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var currTouchX = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(0);
    var prevTouchX = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(0);
    var timeInterval = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(0);
    var nextIdx = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(1);
    var itemsLength = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(items.length);
    var mode = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)('LOCK');
    var unify = function(e) {
        return e.changedTouches ? e.changedTouches[0] : e;
    };
    var onAllowTouch = function(e) {
        if ((0,lib_utils_format_time__WEBPACK_IMPORTED_MODULE_2__/* .getKoreaDate */ .jw)().getTime() - timeInterval.current > 100) {
            e.preventDefault();
        }
    };
    var onMouseMove = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(e) {
        if (e.cancelable) {
            e.preventDefault();
        }
        currTouchX.current = "".concat(Math.round(unify(e).clientX - prevTouchX.current));
        slider.current.style.transform = "translateX(calc(".concat(currTouchX.current, "px + ").concat(nextIdx.current, " * -100%))");
    }, []);
    var onMouseUp = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(e) {
        var diffX = unify(e).clientX - prevTouchX.current;
        var signX = Math.sign(diffX);
        var frame = +(signX * diffX / slider.current.clientWidth).toFixed(2);
        if (Math.abs(diffX) > slider.current.clientWidth / 30) {
            if (signX < 0) {
                mode.current = 'NEXT';
                nextIdx.current += 1;
            } else {
                mode.current = 'PREV';
                nextIdx.current -= 1;
            }
            frame = 1 - frame;
        } else {
            mode.current = 'LOCK';
        }
        prevTouchX.current = 0;
        currTouchX.current = 0;
        slider.current.style.transform = "translateX(calc(".concat(currTouchX.current, "px + ").concat(nextIdx.current, " * -100%))");
        slider.current.style.transition = "transform calc((".concat(frame, ") * .2s) ease-out");
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
        document.removeEventListener('touchmove', onMouseMove);
        document.removeEventListener('touchend', onMouseUp);
    }, [
        onMouseMove
    ]);
    var onMouseDown = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(e) {
        if (!e.type === 'touchstart') {
            e.preventDefault();
        }
        timeInterval.current = new Date().getTime();
        prevTouchX.current = unify(e).clientX;
        slider.current.style.transition = "";
        document.addEventListener('mousemove', onMouseMove, {
            passive: false
        });
        document.addEventListener('mouseup', onMouseUp);
        document.addEventListener('touchmove', onMouseMove, {
            passive: false
        });
        document.addEventListener('touchend', onMouseUp);
    }, [
        onMouseMove,
        onMouseUp
    ]);
    var onTransitionEnd = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (mode.current === 'NEXT') {
            setList(function(v) {
                var first = v.slice(0, 1);
                var other = v.slice(1);
                return _toConsumableArray(other).concat(_toConsumableArray(first));
            });
            setIdx(function(prev) {
                return prev + 1 > itemsLength.current ? prev % itemsLength.current + 1 : prev + 1;
            });
            nextCallback && nextCallback();
        } else if (mode.current === 'PREV') {
            setList(function(v) {
                var last = v.slice(-1);
                var other = v.slice(0, -1);
                return _toConsumableArray(last).concat(_toConsumableArray(other));
            });
            setIdx(function(prev) {
                return prev - 1 === 0 ? itemsLength.current : prev - 1;
            });
            prevCallback && prevCallback();
        }
        slider.current.style.transform = "translateX(-100%)";
        slider.current.style.transition = "";
        nextIdx.current = 1;
    }, [
        prevCallback,
        nextCallback
    ]);
    var onPrev = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        mode.current = 'PREV';
        onTransitionEnd();
    }, [
        onTransitionEnd
    ]);
    var onNext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        mode.current = 'NEXT';
        onTransitionEnd();
    }, [
        onTransitionEnd
    ]);
    /** 아이템 리스트 변경 */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (items.length === 1) {
            setList(items);
            return;
        }
        if (items.length === 2) {
            if (startIndex === 1) {
                setList(_toConsumableArray(items).concat(_toConsumableArray(items)));
                return;
            }
            setList(_toConsumableArray(items).concat(_toConsumableArray(items)).reverse());
            return;
        }
        setList(function() {
            var last = startIndex === 0 ? items.slice(-1) : items.slice(startIndex - 1);
            var other = startIndex === 0 ? items.slice(0, -1) : items.slice(0, startIndex - 1);
            return _toConsumableArray(last).concat(_toConsumableArray(other));
        });
    }, [
        items,
        startIndex
    ]);
    /* eslint-disable */ /** Slider 초기 위치 */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!slider.current) {
            return;
        }
        if (items.length === 1) {
            slider.current.style.transform = "translateX(0%)";
        } else {
            slider.current.style.transform = "translateX(-100%)";
        }
    }, [
        items.length,
        slider.current
    ]);
    /* eslint-enable */ /* eslint-disable */ /** 이벤트 등록 */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (items.length === 1) {
            return;
        }
        var target = slider.current;
        if (!target) {
            return;
        }
        target.addEventListener('touchstart', onMouseDown, {
            passive: false
        });
        target.addEventListener('mousedown', onMouseDown, {
            passive: false
        });
        target.addEventListener('transitionend', onTransitionEnd);
        target.addEventListener('click', onAllowTouch);
        return function() {
            target.removeEventListener('touchstart', onMouseDown, {
                passive: false
            });
            target.removeEventListener('mousedown', onMouseDown), {
                passive: false
            };
            target.removeEventListener('transitionend', onTransitionEnd);
            target.removeEventListener('click', onAllowTouch);
        };
    }, [
        onMouseDown,
        onTransitionEnd,
        items.length,
        slider.current
    ]);
    /* eslint-enable */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        return itemsLength.current = items.length;
    }, [
        items.length
    ]);
    // eslint-disable-next-line react/display-name
    var Slider = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.memo(function(param) {
        var children = param.children;
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(List, {
            ref: slider,
            children: children
        });
    }, []);
    return {
        currentIndex: idx,
        currentList: list,
        Slider: Slider,
        onPrev: onPrev,
        onNext: onNext
    };
};
var List = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-4756cbeb-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (useSwipe);


/***/ }),

/***/ 8224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ range; },
/* harmony export */   "y": function() { return /* binding */ getShuffledArray; }
/* harmony export */ });
/**
 * 배열 생성
 * @param {number} start
 * @param {number} end
 * @returns object[]
 */ var range = function(start, end) {
    var ans = [];
    for(var i = start; i <= end; i++){
        ans.push(i);
    }
    return ans;
};
/**
 * 배열 원소를 랜덤으로 섞고 새로운 배열을 반환한다.
 * @param {object} arr
 * @returns {object[]}
 */ var getShuffledArray = function(arr) {
    var newArr = arr.slice();
    for(var i = newArr.length - 1; i > 0; i--){
        var rand = Math.floor(Math.random() * (i + 1));
        var ref;
        ref = [
            newArr[rand],
            newArr[i]
        ], newArr[i] = ref[0], newArr[rand] = ref[1], ref;
    }
    return newArr;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2725,1223,5644,9809,4739,9774,2888,179], function() { return __webpack_exec__(8581); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);